import { Container, Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { App } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

import { useStateValue } from "../../config/AppContext";
import { formatDate } from "../../utils/time-utils";

const useStyles = makeStyles((theme) => ({
  statistics: {
    marginTop: theme.spacing(2),
    paddingRight: 15,
    "& h5": {
      fontSize: 14,
      fontWeight: 600,
      color: "#333333",
      textAlign: "center",
      textTransform: "none",
      marginBottom: 25,
      [theme.breakpoints.up("md")]: {
        textAlign: "left",
      },
    },
    "& .MuiGrid-container": {
      paddingLeft: 15,
      [theme.breakpoints.up("md")]: {
        paddingLeft: 0,
      },
    },
    "& .MuiPaper-root": {
      height: 70,
      marginBottom: 0,
      width: "80%",
      padding: 12,
      [theme.breakpoints.up("md")]: {
        height: 56,
        marginBottom: 12,
      },
      "& .MuiTypography-body1": {
        fontSize: 17,
        color: "#4A4A4A",
        textAlign: "center",
        [theme.breakpoints.up("md")]: { float: "left", textAlign: "left" },
      },
      "& .MuiTypography-body2": {
        fontSize: 19,
        fontWeight: "bold",
        color: "#FFB319",
        textAlign: "center",
        [theme.breakpoints.up("md")]: { float: "right", textAlign: "left" },
      },
    },
  },
}));

const Statistics: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { Methods } = useStateValue() as {
    Methods: App.Methods;
  };

  const [stats, setStats] = React.useState<{
    range?: { from: string; to: string };
    total?: number;
    completed?: number;
    upcoming?: number;
    cancelled?: number;
  }>();

  React.useEffect(() => {
    if (stats) return;

    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const from = formatDate(firstDay, 3);
    const to = formatDate(lastDay, 3);
    if (from.length > 0 && to.length > 0) {
      const params = {
        from,
        to,
      };

      Methods.getStats(params).then((data) => {
        let total = 0;
        let completed = 0;
        let upcoming = 0;
        let cancelled = 0;
        if (!data)
          return setStats({
            total,
            completed,
            upcoming,
            cancelled,
            range: { from, to },
          });
        data.forEach((d: any) => {
          d.stats.forEach((stat: { state: string; count: number }) => {
            if (stat.state === "COMPLETED") completed += stat.count;
            if (stat.state === "CANCELLED") cancelled += stat.count;
            if (stat.state === "NONE") upcoming += stat.count;
            total += stat.count;
          });
        });
        return setStats({
          total,
          completed,
          upcoming,
          cancelled,
          range: { from, to },
        });
      });
    }
  }, [Methods, stats]);

  return (
    <Container id="Statistics" className={classes.statistics}>
      <Typography variant="h5">{t("Sessions this month")}</Typography>
      <Grid container>
        <Grid item xs={6} md={12}>
          <Paper>
            <Typography variant="body1">{t("In total")}</Typography>
            <Typography variant="body2">{stats && stats.total ? stats.total : 0}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={6} md={12}>
          <Paper>
            <Typography variant="body1">{t("Upcoming")}</Typography>
            <Typography variant="body2">{stats && stats.upcoming ? stats.upcoming : 0}</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Statistics;
